module.exports = __webpack_public_path__ + "img/86ne.7f7586cf.svg";